import { COUNTRY_CODES } from '../data';
import { getFunctionsInstance } from '../firebaseServiceLocator';

export async function readCountryEconomicData(country: string): Promise<any> {
    const code = Object.entries(COUNTRY_CODES).find(([name, codes]) =>
        [name, codes.iso2, codes.iso3].some(value => value?.toLowerCase() === country.trim().toLowerCase()))?.[1].iso3;
    const app = getFunctionsInstance()?.app;
    if (!code || !app)
        return null;
    try {
        const { getFirestore, doc, getDoc } = await import('firebase/firestore');
        const snapshot = await getDoc(doc(getFirestore(app), 'daily_country_analysis', code));
        return snapshot.exists() ? snapshot.data() : null;
    } catch (error) {
        console.warn('Saved country economics unavailable; reporting explicit data gaps.', error);
        return null;
    }
}
